import { BaseLayer } from '.'
import type { Feature, FeatureCollection, Point } from 'geojson'
import { apiFzu } from '@/apiFzu'
import qtIMG from '@/assets/bouyImg/加油站图标.png' // 默认图标
// import MarkPopup from '../../views/Map/Popup/MarkPopup.vue'

import {
  Cartographic,
  Math,
  Color,
  DistanceDisplayCondition,
  NearFarScalar,
  BillboardGraphics,
  Entity,
  JulianDate,
  Cartesian2,
  LabelGraphics,
  LabelStyle,
  VerticalOrigin,
  HorizontalOrigin,
} from 'cesium'
import { Subscriber } from 'cesium-extends'

export class GasStationLayer extends BaseLayer<{
  click(p: any): void
}> {
  layername: string = '加油站'
  key: string = 'gasStation'

  constructor() {
    super()
    this.once('mounted', (viewer) => {
      this._subscriber = new Subscriber(viewer, { pickResult: { enable: true } })
      this._subscriber.addExternal((_e, result) => {
        const entity = result?.id
        if (!(entity instanceof Entity) || !this.datasource.entities.contains(entity)) return
        const data = entity.properties?.getValue()
        const position = entity.position?.getValue()
        if (!position) return
        const cartographic = Cartographic.fromCartesian(position)
        this.popupCtrl.closeAll()
        // this.popupCtrl.popup({
        //   viewer,
        //   id: entity.id,
        //   Com: MarkPopup as any,
        //   lnglat: [
        //     Math.toDegrees(cartographic.longitude),
        //     Math.toDegrees(cartographic.latitude),
        //   ] as [number, number],
        //   properties: data,
        // })

        data && this.emit('click', data)
      }, 'LEFT_CLICK')
    })
  }

  private async loadGeojson(): Promise<FeatureCollection<Point>> {
    const res = await apiFzu.simpleLayers.simpleLayersControllerGetGasStations()
    const featureCollection: FeatureCollection<Point> = {
      type: 'FeatureCollection',
      features: [],
    }

    res.data.forEach((el) => {
      const geom = el.geom as unknown as Point
      if (!el.geom || !Array.isArray(geom.coordinates) || geom.coordinates.length !== 2) {
        console.warn('Skipping element due to invalid coordinates:', el)
        return
      }
      const [longitude, latitude] = geom.coordinates

      const feature: Feature<Point> = {
        type: 'Feature',
        id: el.id,
        geometry: { type: 'Point', coordinates: [longitude, latitude] },
        properties: el,
      }
      featureCollection.features.push(feature)
    })

    return featureCollection
  }

  async render() {
    const geojson = await this.loadGeojson()
    await this.datasource.load(geojson)
    this.datasource.entities.values.forEach((entity) => {
      this.renderEntity(entity)
    })
  }

  private renderEntity(entity: Entity) {
    const properties = entity.properties?.getValue(JulianDate.now())
    if (!properties) return

    const name = properties.name || ''
    // 定义图标的显示距离条件 - 远距离可见
    const iconDisplayCondition = new DistanceDisplayCondition(0, 30000)
    // 定义标签的显示距离条件 - 只在近距离可见
    const labelDisplayCondition = new DistanceDisplayCondition(0, 10000)

    const scaleDistance = new NearFarScalar(1e3, 1, 3e4, 0.2)

    // 设置图标
    entity.billboard = new BillboardGraphics({
      image: qtIMG,
      disableDepthTestDistance: 3000000,
      scaleByDistance: scaleDistance,
      distanceDisplayCondition: iconDisplayCondition,
      verticalOrigin: VerticalOrigin.CENTER,
      width: 32,
      height: 32,
    })

    // 添加标签
    entity.label = new LabelGraphics({
      text: name,
      font: '16px sans-serif',
      style: LabelStyle.FILL_AND_OUTLINE,
      outlineWidth: 3,
      outlineColor: Color.BLACK,
      fillColor: Color.WHITE,
      verticalOrigin: VerticalOrigin.BOTTOM,
      horizontalOrigin: HorizontalOrigin.CENTER,
      pixelOffset: new Cartesian2(0, -20), // 向上偏移，避免遮挡图标
      distanceDisplayCondition: labelDisplayCondition,
      scaleByDistance: new NearFarScalar(1e3, 0.8, 1e4, 0.5),
      disableDepthTestDistance: 3000000,
      backgroundPadding: new Cartesian2(7, 5),
      backgroundColor: new Color(0, 0, 0, 0.6),
      showBackground: true,
    })
  }
}
